<template>
    <div class="chart">
        <h2 class="chart__title">
            <slot name="title" />
            <VTooltip>
                <span class="icon-info"
                      v-if="infoRef"
                />
                <template #popper>
                    <slot name="tooltip" />
                </template>
            </VTooltip>
        </h2>
        <EmptyChart v-if="showEmptyChart" />
        <slot />
    </div>
</template>

<script>
    import EmptyChart from 'components/user/organizationreport/charts/EmptyChart'
    export default {
        name: 'chart-layout',
        components: {
            EmptyChart
        },
        props: {
            showEmptyChart: Boolean,
            default: false,
            infoRef: {
                type: String
            }
        }
    }
</script>

<style lang="scss">
    .chart {
        background: $ghost_white;
        padding: 20px 20px 0;
        flex: 1;

        &__title {
            font-family: Quicksand-Bold,  sans-serif;
            font-size: 2rem;
            display: flex;
            gap: 10px;
            align-items: center;
        }

        &__tooltip {
            position: relative;
            margin: 2px 0 0;
        }
    }
</style>
